import {
  MainPhotoSection,
  IncreaseSection,
} from "../../MainPage/MainPageStyles";
import FAQMainPhoto from "../../../images/faqMainPhoto.png";
import { NavLink } from "react-router-dom";
import LaptopPhoto from "../../../images/laptop__photo.png";
import { motion } from "framer-motion";
import {
  animationFromTheSide,
  arrAnimation,
} from "../../../animations/animations";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../store/hooks";
import { generateLink } from "../../../functions/routingFuntion";

export const FAQ = () => {
  const language = useAppSelector((state) => state.locale.localStorageValue);
  const { t } = useTranslation();

  return (
    <main>
      <MainPhotoSection style={{ background: "#074275" }}>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="container__standart flex__between"
          style={{ marginBottom: "0px" }}
        >
          <motion.div custom={1} variants={arrAnimation}>
            <h1>{t("faqPage.title1")}</h1>
          </motion.div>
          <motion.div custom={2} variants={arrAnimation}>
            <img src={FAQMainPhoto} alt="#" />
          </motion.div>
        </motion.div>
      </MainPhotoSection>
      <section>
        <div className="container__standart">
          <motion.h2
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3, once: true }}
            variants={animationFromTheSide}
          >
            {t("faqPage.blockInfo1Tit")}
          </motion.h2>
        </div>
      </section>
      <IncreaseSection>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3, once: true }}
          className="flex__between container__standart"
        >
          <motion.div
            custom={1}
            variants={arrAnimation}
            className="web-terminal__info"
          >
            <h2> {t("faqPage.blockInfo2Tit")}</h2>
            <NavLink
              className="white__button flex__center"
              to={generateLink("/auth/register", language)}
            >
              {t("faqPage.blockInfo21")}
            </NavLink>
          </motion.div>
          <motion.div
            custom={2}
            variants={arrAnimation}
            className="web-terminal__photo"
          >
            <img src={LaptopPhoto} alt="" />
          </motion.div>
        </motion.div>
      </IncreaseSection>
    </main>
  );
};
